import { compose } from "redux";
import classNames from "classnames";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import React, { PureComponent, createRef } from "react";

import { Grid, RootRef, ButtonBase, Typography } from "@material-ui/core";

import { Format } from "app/app.constants";
import { formatDate } from "utils/format.util";
import { workScheduleOverrideReasonToString } from "features/planner/planner.mappers";
import { toggleEditWorkScheduleOverrideModal } from "features/planner/employee/employee.actions";

class WorkScheduleOverride extends PureComponent {
  constructor(props) {
    super(props);

    this.root = createRef();

    this.state = {
      rootClientHeight: undefined,
    };
  }

  componentDidMount() {
    const { count } = this.props;

    if (this.root.current && count > 1) {
      this.setState({
        rootClientHeight: this.root.current.clientHeight,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { count } = this.props;

    if (count === 1) {
      this.setState({
        rootClientHeight: undefined,
      });
    }

    if (this.root.current && prevProps.count > 1) {
      this.setState({
        rootClientHeight: this.root.current.clientHeight,
      });
    }
  }

  editWorkScheduleOverrideModal = () => {
    const {
      availabilityOverride,
      dispatchToggleEditWorkScheduleOverrideModal,
    } = this.props;

    dispatchToggleEditWorkScheduleOverrideModal(availabilityOverride);
  };

  render() {
    const { classes, availabilityOverride } = this.props;

    const endDate = formatDate(
      availabilityOverride.get("endDate"),
      Format.workSchedule,
    );

    const startDate = formatDate(
      availabilityOverride.get("startDate"),
      Format.workSchedule,
    );

    const description = workScheduleOverrideReasonToString(
      availabilityOverride.get("overrideReason"),
    );

    return (
      <RootRef rootRef={this.root}>
        <Grid
          xs
          item
          container
          justifyContent="center"
          alignItems="center"
          component={ButtonBase}
          onClick={this.editWorkScheduleOverrideModal}
          title={`${description}, ${startDate} - ${endDate}`}
          className={classNames(classes.availabilityOverride)}
        >
          <Typography
            noWrap
            color="secondary"
            variant="caption"
            className={classes.overrideTitle}
            style={{
              fontSize: this.state.rootClientHeight,
              lineHeight: `${this.state.rootClientHeight}px`,
            }}
          >
            {description}
          </Typography>
        </Grid>
      </RootRef>
    );
  }
}

const styles = theme => ({
  availabilityOverride: ({ availabilityOverride }) => ({
    borderRadius: 2,
    zIndex: theme.zIndex.availabilityOverride,
    overflow: "hidden",
    "&:not(:last-child)": {
      marginBottom: 1,
    },
    ...theme.mixins.workScheduleOverride(
      availabilityOverride.get("overrideReason"),
    ),
  }),
  overrideTitle: {
    fontWeight: theme.typography.fontWeightMedium,
  },
});

export default compose(
  connect(null, {
    dispatchToggleEditWorkScheduleOverrideModal: toggleEditWorkScheduleOverrideModal,
  }),
  withStyles(styles),
)(WorkScheduleOverride);
